export var DynamoDbKeyType;
(function (DynamoDbKeyType) {
    DynamoDbKeyType["DYNAMODB_KEY_TYPE_HASH"] = "HASH";
    DynamoDbKeyType["DYNAMODB_KEY_TYPE_RANGE"] = "RANGE";
})(DynamoDbKeyType || (DynamoDbKeyType = {}));
